import { GridFilterInputValueProps } from '@mui/x-data-grid-pro';
import { useState } from 'react';
import EventNamesAutocomplete from '../../../shared/event-names-autocomplete';
import { eventNames } from '../../../shared/event-names';
import Box from '@mui/material/Box';

export function EventFilter(props: GridFilterInputValueProps) {
  const { item, applyValue } = props;
  const [autoCompleteValue, setAutoCompleteValue] = useState<string>(
    item.value
  );

  const handleFilterChange = (newValue: string) => {
    setAutoCompleteValue(newValue);
    applyValue({ ...item, value: newValue });
  };

  return (
    <Box
      sx={{
        width: 300,
        position: 'relative',
        top: -19.5,
        left: 0,
      }}
    >
      <EventNamesAutocomplete
        autocompleteValue={autoCompleteValue}
        setAutoCompleteValue={handleFilterChange}
        events={eventNames}
        variant="standard"
      />
    </Box>
  );
}
